// Design-system tokens — single source of truth for the warm-pastel palette.
//
// In React/JSX, prefer the Tailwind arbitrary-value classes baked into each
// design-system component (e.g. `bg-[#fff1e8]`). These constants are exposed
// for cases where you need the raw hex programmatically (inline styles,
// canvas drawing, charts, computed CSS).

export const tokens = {
  bg:          '#fafaf7',
  surface:     '#ffffff',
  surface2:    '#f5f4f0',
  surface3:    '#ecebe6',
  line:        '#e7e5df',
  lineStrong:  '#d6d3cb',
  ink:         '#1a1816',
  ink2:        '#3a3733',
  ink3:        '#6b6862',
  ink4:        '#9a968e',
  orange:      '#e85d1f',
  orangeHover: '#d04f15',
  orangeSoft:  '#fff1e8',
  orangeSoft2: '#ffe2cf',
  orangeInk:   '#7a2b08',
  green:       '#2f7d4f',
  greenSoft:   '#e7f3eb',
  amber:       '#b87514',
  amberInk:    '#8a5410',
  amberSoft:   '#fbf1e1',
  red:         '#b3321c',
  redSoft:     '#fbeae6',
  redBorder:   '#f0c9c0',
  blue:        '#1f5fa8',
  blueSoft:    '#eef4fb',
  blueBorder:  '#cbdcf0',
}

// Pre-baked shadow strings (used in box-shadow utility classes too).
export const shadows = {
  sm:    '0 1px 2px rgba(20,20,16,.04)',
  md:    '0 1px 2px rgba(20,20,16,.04), 0 4px 12px rgba(20,20,16,.06)',
  lg:    '0 12px 36px rgba(20,20,16,.10), 0 2px 6px rgba(20,20,16,.05)',
  warm:  '0 1px 2px rgba(232,93,31,.04), 0 6px 16px -12px rgba(232,93,31,.35)',
  warmCta: '0 1px 0 rgba(20,20,16,.04), 0 6px 14px -8px rgba(232,93,31,.55)',
}

// Page font (Inter) — applied at the root if you control the page.
export const fontStack = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif"
